export type AnalyticsJwtPayload = {
  ams_user_id?: string;
  sub?: string;
  email?: string;
};

export type AnalyticsUserIdentity = {
  userId: string;
  email?: string;
};

export const resolveAnalyticsUserIdFromJwtPayload = (payload: AnalyticsJwtPayload): string | undefined =>
  payload.ams_user_id ?? payload.sub;

export const resolveAnalyticsUserIdentityFromJwtPayload = (
  payload: AnalyticsJwtPayload
): AnalyticsUserIdentity | undefined => {
  const userId = resolveAnalyticsUserIdFromJwtPayload(payload);

  if (!userId) {
    return undefined;
  }

  return {
    userId,
    ...(payload.email ? { email: payload.email } : {}),
  };
};
